import PropTypes from "prop-types";
import { PureComponent } from "react";

import { defineMessages, injectIntl } from "react-intl";

import { Link, withRouter } from "react-router-dom";

import { connect } from "react-redux";

import { openModal } from "flavours/glitch/actions/modal";
import { fetchServer } from "flavours/glitch/actions/server";
import { Avatar } from "flavours/glitch/components/avatar";
import { Icon } from "flavours/glitch/components/icon";
import { WordmarkLogo, SymbolLogo } from "flavours/glitch/components/logo";
import Permalink from "flavours/glitch/components/permalink";
import { me } from "flavours/glitch/initial_state";

const Account = connect(state => ({
  account: state.getIn(["accounts", me]),
}))(({ account }) => (
  <Permalink href={account.get("url")} to={`/@${account.get("acct")}`} title={account.get("acct")}>
    <Avatar account={account} size={35} />
  </Permalink>
));

const messages = defineMessages({
  search: { id: "navigation_bar.search", defaultMessage: "Search" },
  compose: { id: "navigation_bar.compose", defaultMessage: "New post" },
  notifications: { id: "navigation_bar.notifications", defaultMessage: "Notifications" },
});

const mapStateToProps = (state) => ({
  signupUrl: state.getIn(["server", "server", "registrations", "url"], null) || "/auth/sign_up",
});

const mapDispatchToProps = (dispatch) => ({
  openClosedRegistrationsModal() {
    dispatch(openModal({ modalType: "CLOSED_REGISTRATIONS" }));
  },
  dispatchServer() {
    dispatch(fetchServer());
  },
});

class Header extends PureComponent {

  static contextTypes = {
    identity: PropTypes.object,
  };

  static propTypes = {
    openClosedRegistrationsModal: PropTypes.func,
    location: PropTypes.object,
    signupUrl: PropTypes.string.isRequired,
    dispatchServer: PropTypes.func,
    intl: PropTypes.object.isRequired,
  };

  componentDidMount () {
    const { dispatchServer } = this.props;
    dispatchServer();
  }

  render () {
    const { signedIn } = this.context.identity;
    const { location, intl } = this.props;

    let content;

    if (signedIn) {
      content = (
        <>
          {location.pathname !== "/search" && <Link to='/search' className='button button-secondary' aria-label={intl.formatMessage(messages.search)}><Icon id='search' /></Link>}
          {location.pathname !== "/notifications" && <Link to='/notifications' className='button button-secondary' aria-label={intl.formatMessage(messages.notifications)}><Icon id='bell' /></Link>}
          {location.pathname !== "/publish" && <Link to='/publish' className='button button-secondary' aria-label={intl.formatMessage(messages.compose)}><Icon id='compose' /></Link>} 
          <Account />
        </>
      );
    }

    return (
      <div className='ui__header'>
        <Link to='/' className='ui__header__logo'>
          <WordmarkLogo />
          <SymbolLogo />
        </Link>

        <div className='ui__header__links'>
          {content}
        </div>
      </div>
    );
  }

}

export default injectIntl(withRouter(connect(mapStateToProps, mapDispatchToProps)(Header)));
